export default function Footer({content}) {
    const year = new Date().getFullYear()
    return(
        <footer className="footer mt-auto">
            <div className="footer-content">
                <p>@ {year} {content.jaluse_tekst}</p>
            </div>
        </footer>
    )
}